import type { Translations } from "../keys.js";

export const ru = {
  eyebrow: "Отчет об активности IBKR",
  title: "Отчет по соотношению P/L",
  uploadMark: "Flex XML",
  uploadTitle: "Перетащите или выберите XML IBKR",
  uploadBody: "Имя, счет и адрес маскируются локально.",
  nfaDisclaimer: "Только для обучения и разбора сделок. Не является финансовым советом.",
  chooseFile: "Выбрать файл",
  account: "Счет",
  name: "Имя",
  neutralName: "момо",
  period: "Период",
  baseCurrency: "Базовая валюта",
  closed: "закрыто",
  executions: "исполнений",
  netRealized: "Чистый реализ. P/L",
  winRate: "Доля побед",
  payoffRatio: "Payoff ratio",
  expectancy: "Ожидание",
  executionRecords: "Исполнения",
  canceledOrders: "Отмененные заявки",
  medianHoldingDays: "Медиана дней удержания",
  commissionDrag: "Комиссии",
  closedTradeSum: "Итог закрытых сделок",
  grossProfitLoss: "Валовая прибыль / убыток",
  averageWinLoss: "Средняя прибыль / убыток",
  perClosedTrade: "На закрытую сделку",
  flexTradeRecords: "Записи Trade в Flex XML",
  flexCanceledRecords: "Отмененные записи Order в Flex XML",
  noCanceledRecords: "Отмененных заявок нет",
  holdingReview: "Holding",
  holdingReviewTitle: "Анализ удержания и payoff",
  holdingReviewHint: "Сопоставляет открытия и закрытия, затем сравнивает PF, payoff и долю побед по срокам удержания.",
  holdingPeriod: "Срок удержания",
  holdingIntraday: "Внутри дня",
  holdingSwing: "1-7 дней",
  holdingPosition: "8-30 дней",
  holdingLongTerm: "30+ дней",
  directionReview: "Direction",
  directionReviewTitle: "Анализ long / short",
  directionReviewHint: "Разделяет закрытые сделки по экспозиции стратегии, чтобы показать более сильную сторону.",
  longPosition: "Long",
  shortPosition: "Short",
  neutralPosition: "Neutral",
  equityCurve: "Кривая капитала",
  dailyRealized: "Дневной реализ. P/L",
  payoff: "Payoff",
  winLossDistribution: "Распределение побед/убытков",
  periodPerformance: "Результаты по периодам",
  periodHint: "Зеленые столбцы: прибыль, красные: убыток. PF и payoff указаны в таблице ниже.",
  weekly: "Неделя",
  monthly: "Месяц",
  periodColumn: "Период",
  monthColumn: "Месяц",
  realized: "Реализ.",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "Payoff",
  trades: "Сделки",
  assetBreakdown: "Активы",
  assetBreakdownTitle: "Статистика акций / опционов",
  asset: "Актив",
  medianPnl: "Медиана P/L",
  average: "Среднее",
  optionReview: "Опционы",
  optionReviewTitle: "Опционы по базовому активу",
  underlying: "Базовый актив",
  date: "Дата",
  dateCount: "Даты",
  daysShort: "д",
  hoursShort: "ч",
  minutesShort: "мин",
  weakestSession: "Слабейшая сессия",
  intradaySessionNoData: "Нет закрытий в регулярную сессию",
  intradaySessionTitle: "Доля побед: открытие / середина / закрытие",
  intradaySessionHint: "Группирует закрытия по времени и сравнивает реализованный P/L, медиану P/L, среднее, PF, payoff и долю побед.",
  weekdayReviewTitle: "Результаты по дням недели",
  weekdayReviewHint: "Сравнивает закрытия регулярной сессии и автоэкспирации по дням недели и показывает лучший и худший payoff.",
  weekday: "День недели",
  weekdaySunday: "Воскресенье",
  weekdayMonday: "Понедельник",
  weekdayTuesday: "Вторник",
  weekdayWednesday: "Среда",
  weekdayThursday: "Четверг",
  weekdayFriday: "Пятница",
  weekdaySaturday: "Суббота",
  bestDay: "Лучший",
  worstDay: "Худший",
  session: "Сессия",
  sessionMorning: "Открытие",
  sessionMidday: "Середина",
  sessionLate: "Закрытие",
  autoExpiry: "Автоэксп.",
  optionLifecycle: "Экспирация / расчёт",
  optionLifecycleRegularClose: "Обычное закрытие",
  optionLifecycleEp: "Истечение",
  optionLifecycleEx: "Исполнение",
  optionLifecycleA: "Назначение",
  optionLifecycleCD: "Денежный расчёт",
  optionLifecycleAEx: "Автоисполнение",
  optionLifecycleMEx: "Ручное исполнение",
  optionLifecycleGEA: "Зачёт: истечение / назначение",
  discipline: "Дисциплина",
  disciplineRisk: "Риск дисциплины",
  largeLossAlert: "Предупреждение о крупном убытке",
  largeLossDiscipline: "Сначала пауза. Сохрани дисциплину.",
  largeLossRule: "Суммарный убыток этого дня выше текущего риск-порога. Не увеличивайте размер ради отыгрыша, пока не проверите плановый стоп, дневной лимит убытка и правило паузы.",
  worstLossDay: "Худший день убытка",
  symbols: "Символы",
  symbolPerformance: "Рейтинг символов",
  page: "Страница",
  previousPage: "Предыдущая страница",
  nextPage: "Следующая страница",
  offlineCoach: "Офлайн-коуч",
  offlineAdvice: "Офлайн-советы",
  bestLoserWins: "Лучший проигрывающий побеждает",
  theme: "Тема",
  language: "Язык",
  dark: "Темная",
  light: "Светлая",
  stock: "Акции",
  option: "Опционы",
  other: "Другое",
  cash: "Деньги",
  future: "Фьючерс",
  unknown: "Неизвестно",
  lossBucketSmall: "Малый убыток",
  lossBucketMedium: "Средний убыток",
  lossBucketLarge: "Крупный убыток",
  winBucketSmall: "Малая прибыль",
  winBucketMedium: "Средняя прибыль",
  winBucketLarge: "Крупная прибыль",
  chartEmpty: "Нет закрытых сделок для графика",
  dailyChartLegend: "столбцы: день, линия: накоплено",
  periodChartLegend: "точки PF, ориентир 1.00, лимит",
  importFailed: "Ошибка импорта",
  profitStatus: "Прибыль",
  lossStatus: "Убыток",
  flatStatus: "Без изм.",
  costStatus: "Затраты",
  toggleDetails: "Показать детали",
  "error.invalid_flex_xml": "Загрузите файл IBKR Flex XML.",
  "advice.profit_factor_below_one.title": "PF ниже 1",
  "advice.profit_factor_below_one.body": "Текущий PF: {profitFactor}. Общая прибыль пока не покрывает общий убыток. Сначала сократите крупные убытки, потери на экспирации и неконтролируемые добавления, а не увеличивайте число сделок.",
  "advice.profit_factor_thin_edge.title": "У PF тонкий запас прочности",
  "advice.profit_factor_thin_edge.body": "Текущий PF: {profitFactor}. Торговать можно, но один-два неконтролируемых убытка могут стереть результат периода. Сначала задайте дневной лимит убытка, крайнее время выхода и правила паузы.",
  "advice.profit_factor_healthy.title": "Структура PF выглядит здоровее",
  "advice.profit_factor_healthy.body": "Текущий PF: {profitFactor}. Не повышайте частоту вслепую. Найдите повторяемые символы, сессии и сетапы, затем оставьте только более качественные сделки.",
  "advice.winrate_and_payoff_weak.title": "Win rate и payoff не должны быть слабыми одновременно",
  "advice.winrate_and_payoff_weak.body": "Доля побед: {winRate}, payoff: {payoffRatio}. Ни точность, ни среднее вознаграждение пока не компенсируют риск. Перед входом строже проверяйте цель и дистанцию стопа.",
  "advice.high_winrate_weak_payoff.title": "Win rate прикрывает слабый payoff",
  "advice.high_winrate_weak_payoff.body": "Доля побед: {winRate}, но payoff: {payoffRatio}. Одна плохая сделка может съесть несколько хороших. Чаще это проблема выхода и определения риска, а не только направления.",
  "advice.overtrade_loss_days.title": "В убыточные дни видна акселерация",
  "advice.overtrade_loss_days.body": "{days} дней сочетали много сделок и отрицательный PnL. Отдельно разберите сделки после первого убытка: они были частью плана или попыткой отыграться?",
  "advice.auto_expiry_losses.title": "Автоэкспирационные убытки не являются шумом",
  "advice.auto_expiry_losses.body": "Учтено {count} автоэкспирационных убытков. Экспирация в ноль должна быть управляемым риском, а не случайностью в конце дня. Запишите последнее допустимое время выхода.",
  "advice.good_loser_base.title": "Хороший проигравший защищает следующую сделку",
  "advice.good_loser_base.body": "Средняя прибыль: {avgWin}, средний убыток: {avgLoss}. Убытки внутри плана — это издержки; убытки вне плана означают, что риск нужно сузить.",
  "advice.detach_outcome_from_ego.title": "Отделите PnL от эго",
  "advice.detach_outcome_from_ego.body": "На разборе сначала спросите: этот убыток случился по плану? Если да, это издержка. Если нет, это проблема дисциплины.",
  "advice.large_tail_losses.title": "Сначала уменьшите самые крупные убытки",
  "advice.large_tail_losses.body": "{count} убытков превысили {threshold}. Самый быстрый путь улучшить PF обычно не повышение win rate, а сокращение хвостовых убытков, которые ломают всю неделю.",
  "advice.asset_group_relative_edge.title": "{stronger} сейчас имеют относительное преимущество",
  "advice.asset_group_relative_edge.body": "PF опционов: {optionProfitFactor}; PF акций: {stockProfitFactor}. Направьте капитал и внимание туда, где PF стабильнее, затем проверьте, не был ли слабый сегмент случайным тестом или эмоциональной торговлей.",
  "advice.option_sample_dominant.title": "Текущая выборка в основном состоит из опционов",
  "advice.option_sample_dominant.body": "PF опционов: {optionProfitFactor}, доля побед: {optionWinRate}. Разберите отдельно экспирацию, исполнение/назначение, решения последней сессии и изменения IV.",
  "advice.stock_sample_dominant.title": "Текущая выборка в основном состоит из акций",
  "advice.stock_sample_dominant.body": "PF акций: {stockProfitFactor}, доля побед: {stockWinRate}. Проверьте время удержания, последовательность стопов и входы в погоню, прежде чем смешивать акции с опционами.",
  "advice.weak_option_underlying_days.title": "Слабые опционные символ-дни нужно разобрать отдельно",
  "advice.weak_option_underlying_days.body": "{rows}. Эти комбинации ближе к реальному контексту решения, чем сводная таблица. Сначала проверьте направление, время входа и близость экспирации.",
  "advice.clean_sample.title": "Держите выборку чистой",
  "advice.clean_sample.body": "Ни одна группа активов явно не тянет результат вниз. Продолжайте собирать чистые закрытые сделки, затем проверьте цикличность, концентрацию по символам и стабильность сетапов.",
} satisfies Translations;
